import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { PropertyDto } from '@workspace/data-types';
import { EtxeEnumsNiceLabelUtils } from '../../../utils/etxe-enums-nice-label.utils';
import { PropertyHoverPreviewDirective } from '../property-hover-card';

@Component({
  selector: 'etxe-property-explore-card',
  standalone: true,
  imports: [DecimalPipe, RouterLink, MatIconModule, MatTooltipModule, PropertyHoverPreviewDirective],
  templateUrl: './property-explore-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyExploreCardComponent {
  readonly property = input.required<PropertyDto>();
  readonly maxCandidates = input<number>(5);
  readonly compact = input<boolean>(false);

  readonly coverPhotoUrl = computed<string | null>(() => {
    const prop = this.property();
    if (
      prop.media?.coverPhoto &&
      typeof prop.media.coverPhoto === 'object' &&
      'url' in prop.media.coverPhoto &&
      prop.media.coverPhoto.url
    ) {
      return prop.media.coverPhoto.url as string;
    }
    if (prop.media?.photos && prop.media.photos.length > 0 && prop.media.photos[0]?.url) {
      return prop.media.photos[0].url;
    }
    return null;
  });

  readonly isApplied = computed<boolean>(() => {
    return !!this.property().application?.isApplied;
  });

  readonly candidatesCount = computed<number>(() => {
    return this.property().application?.acceptedCount ?? 0;
  });

  readonly appliedCount = computed<number>(() => {
    return this.property().application?.appliedCount ?? 0;
  });

  readonly isAcceptingCandidates = computed<boolean>(() => {
    return this.property().application?.accepting ?? true;
  });

  readonly roomsCount = computed<number>(() => {
    return this.property().characteristics?.interior?.rooms?.length ?? 0;
  });

  readonly bedroomsCount = computed<number>(() => {
    return this.property().characteristics?.interior?.bedroom?.length ?? 0;
  });

  readonly propertyTypeLabel = computed<string>(() => {
    const type = this.property().definition?.propertyType;
    return type ? EtxeEnumsNiceLabelUtils.propertyType(type) : 'Bien';
  });

  readonly mandateTypeLabel = computed<string>(() => {
    return EtxeEnumsNiceLabelUtils.mandateType(this.property().mandate?.type);
  });

  readonly mandateDurationLabel = computed<string>(() => {
    return EtxeEnumsNiceLabelUtils.mandateDuration(this.property().mandate?.duration);
  });
}
